import React from 'react';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import {
    ESTILO_EXPRES,
    etiquetaCortaMotivoExpres,
    etiquetaMotivoExpres,
} from '../../constants/tramiteExpres';

/**
 * En el trámite exprés (V249) la píldora del tipo de trámite muestra por qué volvió el cliente: el
 * tipo guardado es el heredado del turno anterior (o GENERAL si no lo hubo) y no dice nada de esta
 * visita. Es la misma píldora que la del tipo (.rec-chip-tramite), en el azul del exprés; con
 * `conIcono` lleva el mismo ícono que la del Panel Diario.
 *
 * El texto va corto para que entre en la píldora; el completo queda en el title.
 */
function ChipMotivoExpres({ turno, conIcono = false, className = '' }) {
    const completo = etiquetaMotivoExpres(turno?.expresMotivo, turno?.expresMotivoDetalle) || 'Trámite exprés';
    return (
        <span
            className={`rec-chip-tramite rec-chip-motivo-expres ${className}`.trim()}
            style={{ backgroundColor: ESTILO_EXPRES.bg, color: ESTILO_EXPRES.text, borderColor: `${ESTILO_EXPRES.text}33` }}
            title={`Trámite exprés: ${completo}`}
        >
            {conIcono && (
                <ReceiptLongIcon className="panel-diario-tramite-badge-icono" style={{ color: ESTILO_EXPRES.text }} />
            )}
            <span className="rec-chip-motivo-expres-texto">
                {etiquetaCortaMotivoExpres(turno?.expresMotivo, turno?.expresMotivoDetalle)}
            </span>
        </span>
    );
}

export default ChipMotivoExpres;
